import styled from 'styled-components';
import { palette, tokens } from '@plataforma/components';

export const Gif = styled.img`
  width: 240px;
  height: 155.6px;
`;

export const Image = styled.img`
  width: 283px;
  height: 180px;
  filter: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.1));
`;

export const Title = styled.h2`
  ${tokens.font['xl-emphasys']};
  margin-bottom: ${tokens.spacing.m};
  color: ${palette['color-dark']};

  & span {
    color: ${palette['color-brand-primary']};
  }
`;

export const Text = styled.p`
  ${tokens.font.s};
  margin: ${tokens.spacing.m} 0;
  color: ${palette['color-dark']};
`;
